import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c5ef516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "favorite-list-container" }
const _hoisted_2 = { class: "tab-wrapper" }
const _hoisted_3 = {
  ref: "scrollWrapper",
  class: "list-wrapper"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, " 즐겨찾기를 삭제하시면 설정하신 모든 정보가 삭제됩니다. 즐겨찾기를 삭제하시겠습니까? ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["Tabs"], {
          tabList: $setup.FAVORITE_CATEGORY,
          currentTabIndex: $setup.selectedTabIndex,
          onOnChangeTab: $setup.updateSelectedTabIndex
        }, null, 8 /* PROPS */, ["currentTabIndex"]),
        _createCommentVNode(" 만석 노선 갯수 표시 버튼 "),
        ($props.fullSeatLineRouteCount)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "full-lines-btn underline",
              type: "button",
              onClick: $setup.handleClickFullSeatLinesButton
            }, " 만석 노선 " + _toDisplayString($props.fullSeatLineRouteCount), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        ($setup.selectedTabIndex === 0)
          ? (_openBlock(), _createBlock($setup["FavoriteLineList"], {
              key: 0,
              favoriteLines: $props.favoriteLines,
              onOnClickRow: $setup.handleClickRow,
              onOnClickFavoriteStatusButton: $setup.handleClickLineFavoriteStatusButton,
              onOnClickBoardingStatusButton: $setup.emitOnClickBoardingStatusButton,
              role: "tabpanel",
              id: `tab-panel-0`,
              "aria-labelledby": `tab-0`
            }, null, 8 /* PROPS */, ["favoriteLines"]))
          : (_openBlock(), _createBlock($setup["FavoriteBusStopList"], {
              key: 1,
              favoriteBusStops: $setup.favoriteBusStops,
              onOnSuccessRemoveFavoriteBusStop: $setup.filterFavoriteBusStop,
              role: "tabpanel",
              id: `tab-panel-1`,
              "aria-labelledby": `tab-1`
            }, null, 8 /* PROPS */, ["favoriteBusStops"]))
      ], 512 /* NEED_PATCH */),
      ($setup.scrollWrapper)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            class: "scroll-top-warpper",
            container: $setup.scrollWrapper
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.shouldShowFavoriteLineRemoveAlert)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "즐겨찾기 삭제",
          okButtonTitle: "삭제하기",
          cancelButtonTitle: "취소",
          onOnClickOkButton: $setup.handleClickFavoriteLineRemoveAlertOk,
          onOnClickCancelButton: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowFavoriteLineRemoveAlert(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($setup.shouldShowFullSeatLines)
      ? (_openBlock(), _createBlock($setup["FullSeatLinesModal"], {
          key: 1,
          fullSeatLines: $setup.fullSeatLineList,
          onOnClickClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowFullSeatLines(false)))
        }, null, 8 /* PROPS */, ["fullSeatLines"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}